export default __webpack_public_path__ + "static/media/applogo.721211f7.png";